export const blockIconsHomeShieldMoon = (
	<span className='material-symbols-outlined'>shield_moon</span>
);
